import axios from 'axios';
import api from '@baza/store/api';

const state = {
    items: [],
    item: {},
    hiddenFormOffer: {},
    load: false,
    loadedRoute: false,
    loadedOffer: false,
};
const getters = {};
const actions = {
    getItems(context, data) {
        context.commit('setItems', []);
        context.commit('setLoad', true);
        return api.get('/offer', { filter: { code: data.code, popular: data.popular } }).then((r) => {
            context.commit('setItems', r);
            context.commit('setLoad', false);
            context.commit('setLoadedRoute', data.code);
        });
    },
    getItem(context, data) {
        context.commit('setItem', {});
        context.commit('setLoad', true);
        api.get(`/offer/${data.id}`, {}).then((r) => {
            context.commit('setItem', r);
            context.commit('setLoad', false);
            context.commit('setLoadedOffer', data.id);
        });
    },
    getHiddenFormOffer(context, id) {
        context.commit('setHiddenFormOffer', {});
        return api.get(`/hiddenForm/${id}`, {}).then((r) => {
            context.commit('setHiddenFormOffer', r);
            return r;
        });
    },
    sendOrder(context, data) {
        api.post('/offer/order', {}, data).then(() => {});
    },
};
const mutations = {
    setLoad(state, data) {
        state.load = data;
    },
    setItems(state, data) {
        state.items = data;
    },
    setItem(state, data) {
        state.item = data;
    },
    setHiddenFormOffer(state, data) {
        state.hiddenFormOffer = data;
    },
    setLoadedRoute(state, data) {
      state.loadedRoute = data;
    },
    setLoadedOffer(state, data) {
      state.loadedOffer = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
